import React, { Component } from 'react';
import '../../styles/commoncomponents/showEntries.scss';

class showEntries extends Component {

    handleSelect(e) {
        this.props.showEntriesCallback(e.target.value)
    }

    render() {

        return (
            <div className="showEntriesSelect">
                Show <select onChange={this.handleSelect.bind(this)} >
                    {this.props.data.map((item, index) => {
                        return (<option key={index} value={item}>{item == 1000000 ? "All" : item}</option>)
                    })}
                </select> entries
            </div>
        );
    }
}

export default showEntries;
